var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("SearchableDocumentsList", {
    attrs: {
      query: _vm.query,
      companyId: _vm.companyId,
      currentUser: _vm.currentUser,
      outerFilterTouched: _vm.filtersTouched,
    },
    scopedSlots: _vm._u([
      {
        key: "filters",
        fn: function () {
          return [
            _c("ContractorsMultiselect", {
              staticClass: "documents__multiselect",
              attrs: {
                value: _vm.selectedContractorsIds,
                contractorsConditions: _vm.contractorsListConditions,
                placeholder: "Select contractors",
              },
              on: { input: _vm.onContractorSelected },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }